import { CreditCardEnum } from '@sola/schema/dotcom/checkout/billingInfo.js';
import { BeneficiaryAvailabilityCheckState } from '@sola/schema/dotcom/children/hold.js';
import { CreditCardType } from '@sola/schema/dotcom/proxy-api/transactions.js';

import { SupporterURLAttributes } from '../types/requests';
import { getSupporterAttribute } from './routes';

export const toNearestCent = (amount: number): number =>
  Math.round(100 * amount) / 100;

export const getCreditCardTypeFromCardNumber = (
  number: string,
): CreditCardEnum => {
  switch (number?.charAt(0)) {
    case '4':
      return CreditCardEnum.Visa;
    case '5':
    case '2':
      return CreditCardEnum.Mastercard;
    case '6':
      return CreditCardEnum.Discover;
    case '3':
      return CreditCardEnum.Amex;
    default:
      return CreditCardEnum.NA;
  }
};

export const mapCardTypeToCardEnum = (
  cardType: CreditCardType,
): CreditCardEnum => {
  switch (cardType) {
    case CreditCardType.VISA:
      return CreditCardEnum.Visa;
    case CreditCardType.MC:
      return CreditCardEnum.Mastercard;
    case CreditCardType.AMEX:
      return CreditCardEnum.Amex;
    case CreditCardType.DISC:
      return CreditCardEnum.Discover;
    default:
      return CreditCardEnum.NA;
  }
};

export const getChildAvailabilityStateFromStatus = (
  statusCode: number,
  state?: BeneficiaryAvailabilityCheckState,
) => {
  switch (statusCode) {
    case 200:
      return BeneficiaryAvailabilityCheckState.Available;
    case 409:
      return BeneficiaryAvailabilityCheckState.Temporary;
    case 410: {
      if (state) {
        return state;
      }
      return BeneficiaryAvailabilityCheckState.Gone;
    }
    default:
      return BeneficiaryAvailabilityCheckState.Gone;
  }
};

/** Function that checks if function is fired server side or client side */
export const isServerSide = (): boolean => {
  return !(typeof window !== 'undefined' && window.document);
};

export const fetchSupporterAttribute = async <T>(
  supporterId: string,
  urlAttributeKey: SupporterURLAttributes,
  // cacheAttributeKey: SupporterCachedAttributesKeys,
) => {
  // const localAttribute =
  //   !isServerSide() && getSupporterAttributeFromCache(cacheAttributeKey);

  // // returning from cache...
  // if (localAttribute) return localAttribute as T;

  // returning from fetch req
  const supporterAttributes = await getSupporterAttribute<T>(
    supporterId,
    urlAttributeKey,
  );

  // if (supporterAttributes && !isServerSide()) {
  //   // Store in cache
  //   saveSupporterAttributeToCache(cacheAttributeKey, supporterAttributes);
  // }

  return supporterAttributes;
};
